/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector ,useDispatch} from 'react-redux';
import TableBodyProvider from './TableBody';

const ProviderTable=({pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg,patientId})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows?.topCheckBox)
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const dispatch=useDispatch()
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const handleSort = (key) => {
        setisSortSelected(true)
        if(sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }

    return(
        <div>
            <div className='2xl:h-[calc(100vh-314px)] xl:h-[calc(100vh-319px)] h-[calc(100vh-319px)] pagination_bottom1 overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[1]">
                            <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm"  onClick={() => {handleSort('user_id')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                    <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "user_id" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="username" className="px-[18px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm"  onClick={() => {handleSort('first_name')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">First Name
                                    <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "first_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="firstname" className="px-[18px] py-2 min-w-[180px] rounded-tl-sm rounded-bl-sm"  onClick={() => {handleSort('last_name')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Last Name
                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "last_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="middlename" className="px-[18px] py-2 min-w-[180px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Preference Mode
                                    
                                </span>
                            </th>
                            <th id="lastname" className="px-[18px] py-2 min-w-[180px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number
                                </span>
                            </th>
                          
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                    Alerts by SMS
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                    Alerts by Email
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[220px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                    Include Missed Readings
                                </span>
                            </th>
                            <th  className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Enable Alerts
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBodyProvider
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    patientId={patientId}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default ProviderTable